<template>
    <div class="procurement-hall">
        <div class="container">
            <!-- 排序选项卡 -->
            <div class="sort-tabs">
                <el-tabs v-model="activeSort" class="procurement-tabs" @tab-click="handleTabClick">
                    <el-tab-pane label="最新发布" name="1"></el-tab-pane>
                    <el-tab-pane label="最近距离" name="2"></el-tab-pane>
                    <el-tab-pane label="常用订单" name="3"></el-tab-pane>
                    <el-tab-pane label="订单金额" name="4">

                        <el-dropdown trigger="hover" popper-class="province-dropdown" style="padding-top: 2px;">
                            <div class="sort-item">
                                <!-- 订单金额 -->
                                <img src="../../assets/images/23.png" alt="" style="width: 6px;height: 6px;">
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <div class="province-list">
                                    <div v-for="(item, index) in cgdtMoneyList" :key="index" class="province-item"
                                        @click="selectItem(item)">
                                        {{ item.min_money }}-{{ item.max_money }}
                                    </div>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-tab-pane>

                </el-tabs>
            </div>

            <!-- 采购单表格 -->
            <div class="table-container">
                <el-table :data="procurementList" border stripe style="width: 100%">
                    <el-table-column prop="order_sn" label="采购单号" width="200"></el-table-column>
                    <el-table-column prop="title"  label="采购标题" min-width="250"></el-table-column>
                    <el-table-column  label="采购电话" width="120">
						<template slot-scope="scope">
						    {{ maskMobile(scope.row.mobile) }}
						</template>
					</el-table-column>
                    <el-table-column prop="settle_type_name" label="结算周期" width="100"></el-table-column>
                    <el-table-column prop="last_time" label="更新时间" width="120"></el-table-column>
                    <el-table-column prop="query_end_day" label="采购截止时间" width="150">
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button size="small" @click="handleQuote(scope.row)" class="baojia_btn"
                                :class="{ 'is_quoted': scope.row.is_quotation == 1 }"
                                :disabled="scope.row.is_quotation == 1">
                                {{ scope.row.is_quotation == 1 ? '已报价' : '去报价抢单' }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页控件 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProcurementHall',

    data() {
        return {
            // 排序选项卡
            activeSort: 'latest',
            // 表格数据
            procurementList: [],
            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,

            cgdtMoneyList: [],
            locationInfo: {},
            sort: '1',
            min_money: '',
            max_money: '',
        }
    },
    mounted() {
        // 初始化加载数据
        this.getCgdtList()
        this.getCgdtMoneyList1();
        this.locationInfo = JSON.parse(localStorage.getItem('locationInfo'));
    },
    computed: {
        // 通过getter获取cityCode
        cityCode() {
            return this.$store.getters.getCityCode[1];
        },
        // 判断用户是否已登录
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
    watch: {
        cityCode(newVal, oldVal) {
            this.getCgdtList()
        }
    },
    filters: {
        formatDate: function (seconds) {
            // 检查输入是否为有效数字
            if (!seconds || isNaN(seconds) || seconds < 0) return '已结束';

            // 计算天时分秒
            const days = Math.floor(seconds / (60 * 60 * 24));
            const hours = Math.floor((seconds % (60 * 60 * 24)) / (60 * 60));
            const minutes = Math.floor((seconds % (60 * 60)) / 60);
            const remainingSeconds = Math.floor(seconds % 60);

            // 格式化输出
            const parts = [];
            if (days > 0) {
                parts.push(`${days}天`);
            }
            if (hours > 0 || days > 0) {
                parts.push(`${hours.toString().padStart(2, '0')}时`);
            }
            parts.push(`${minutes.toString().padStart(2, '0')}分`);
            // parts.push(`${remainingSeconds.toString().padStart(2, '0')}秒`);

            return parts.join('');
        }
    },
    methods: {
        // 处理选项卡点击事件
        handleTabClick(tab) {
            this.sort = tab.name;
            this.min_money = '';
            this.max_money = '';
            this.getCgdtList();
        },

        // 选择订单金额区间
        selectItem(item) {
            this.sort = '4';
            this.min_money = item.min_money;
            this.max_money = item.max_money;
            this.getCgdtList();
        },
        // 获取采购大厅列表
        getCgdtList() {
            let data = {
                sort: this.sort, //1 最新发布 2 距离 3常用订单 4 订单金额
                lat: this.locationInfo ? this.locationInfo.lat : '',
                lng: this.locationInfo ? this.locationInfo.lng : '',
                min_money: this.min_money,
                max_money: this.max_money,
                keyword: this.keyword,
                region_code: this.cityCode,
                page: this.currentPage,
                list_rows: this.pageSize,
            }
            this.$api.getCgdtList(data).then(res => {
                this.procurementList = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 去报价抢单
        handleQuote(row) {
            this.$router.push({
                path: '/PurchaseDetails',
                query: {
                    aid: row.aid
                }
            })
        },
        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCgdtList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCgdtList();
        },

        getCgdtMoneyList1() {
            this.$api.getCgdtMoneyList1().then(res => {
                this.cgdtMoneyList = res;
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 手机号脱敏：未登录隐藏中间4位，登录后完整展示
        maskMobile(mobile) {
            console.log(this.isLoggedIn)
            console.log(mobile)
            if (!mobile) return '';
            if (this.isLoggedIn) return mobile;
            // 未登录脱敏：13812345678 -> 138****5678
            const str = String(mobile);
            if (str.length >= 7) {
                return str.substring(0, 3) + '****' + str.substring(str.length - 4);
            }
            return str;
        }
    }
}
</script>

<style scoped>
.procurement-hall {
    background-color: #f5f5f5;
    min-height: calc(100vh - 120px);
    padding: 20px 0;
}

.container {
    width: 1200px;
    margin: 0 auto;
}

/* 排序选项卡 */
.sort-tabs {
    margin-bottom: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 0 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

/* 自定义Element UI标签页样式 */
::v-deep .procurement-tabs {
    display: flex;
    align-items: center;
}

::v-deep .procurement-tabs .el-tabs__header .is-top::after {
    background-color: transparent !important;
}

::v-deep .procurement-tabs .el-tabs__nav-wrap::after {
    background-color: transparent !important;
}

::v-deep .procurement-tabs .el-tabs__active-bar {
    height: 0;
}

::v-deep .procurement-tabs .el-tabs__item {
    border-radius: 4px;
    margin-right: 10px;
    padding: 8px 16px;
    font-size: 14px;
    color: #666666;
    border: 1px solid transparent;
}

::v-deep .procurement-tabs .el-tabs__item.is-active {
    /* background-color: #e8f0fe; */
    color: #286CED;
    /* border: 1px solid #286CED; */
}

/* 表格容器 */
.table-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
}

/* 表格样式 */
::v-deep .el-table {
    border-radius: 8px;
    overflow: hidden;
}

::v-deep .el-table__header-wrapper th {
    background-color: #fafafa;
    font-weight: bold;
    color: #333333;
}

::v-deep .el-table__body-wrapper tr:hover {
    background-color: #f5f7fa;
}

/* 截止时间样式 */
.deadline-text {
    color: #ff4d4f;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

.baojia_btn {
    background: #FFFFFF;
    border: 1px solid #2563E5;
    color: #286CED;

}

.baojia_btn.is_quoted {
    background: #F5F7FA;
    border: 1px solid #DCDFE6;
    color: #C0C4CC;
}

/* 省份下拉框样式 */
.province-dropdown {
    width: 410px !important;
    padding: 10px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
}

.province-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
}

.province-item {
    padding: 8px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    color: #666666;
    border-radius: 4px;
}

.province-item:hover {
    color: #286CED;
    background-color: #f0f4ff;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        width: 100%;
        padding: 0 20px;
    }
}

@media (max-width: 768px) {
    .sort-tabs {
        padding: 15px;
    }

    ::v-deep .procurement-tabs .el-tabs__item {
        padding: 6px 12px;
        font-size: 12px;
        margin-right: 5px;
    }

    .table-container {
        padding: 15px;
    }

    .pagination-container {
        padding: 15px;
        text-align: center;

    }

    ::v-deep .el-pagination {
        font-size: 12px;
    }
}
</style>